import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizableError } from 'src/app/models/LocalizableError';
import { EventService } from 'src/app/services/event.service';
import { EVENT_SERVICE } from '../../../providers/service.providers';
import { BrowserSessionService } from '../../../services/browser-session.service';

@Component({
  selector: 'app-payment-paypal',
  templateUrl: './payment.paypal.html'
})
export class PaymentPaypalComponent implements OnInit {
  public error: LocalizableError;
  @ViewChild('paypal', { static: true }) paypalElement: ElementRef;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      @Inject(EVENT_SERVICE) private eventService: EventService,
      private browserSessionService: BrowserSessionService,
    ) { }

  total: number;
  currencyCode: string;
  ticketName: string;

  registrationInProgress: boolean;

  private readableEventId: string;
  private purchaseId: string;
  private redirectUrl: string;

  ngOnInit() {
    this.total = this.browserSessionService.getRegistrationTotal();
    this.currencyCode = this.browserSessionService.getCurrency();
    this.ticketName = this.browserSessionService.getTicketName();
    this.purchaseId = this.route.snapshot.queryParams['purchaseId'];
    this.redirectUrl = this.browserSessionService.getRedirectUrl();
    this.readableEventId = this.route.snapshot.queryParams['id'];
  }

  cancel(): void {
    this.router.navigate(['/event'], { queryParams: { id: this.readableEventId}});
  }

  goToPayment(): void {
    this.registrationInProgress = true;
    window.location.href = this.redirectUrl;
  }

}
